import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Y from '../../y18n'
import * as subscriptionPackActions from '../../store/subscription-packs'

import Sizes from '../styles/sizes'
import Styles from '../styles'

const mapStateToProps = state => ({
  subscriptionPacks: state.subscriptionPacks
})

const mapDispatchToProps = dispatch => ({
  subscriptionPackActions: bindActionCreators(subscriptionPackActions, dispatch)
})


class SubscriptionPacksDropdown extends Component {
  componentDidMount () {
    if(this.props.subscriptionPacks.items.length === 0 && !this.props.subscriptionPacks.currentState.new){
      this.props.subscriptionPackActions.getSubscriptionPacks()
      this.setState({
        unmount: true
      })
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if(!this.props.subscriptionPacks)
      this.props.subscriptionPackActions.getSubscriptionPacks()
  }

  componentWillUnmount (){
    if(this.props.unmount)
      this.props.subscriptionPackActions.clearSubscriptionPacks()
  }

  render () {
    const { subscriptionPacks, inputProps, value, label, handleChange, fullWidth, required, style, classes, alwaysShowDefaultOption } = this.props

    var items = (inputProps && (inputProps.items || subscriptionPacks.items)) || subscriptionPacks.items,
        active = (inputProps && (inputProps.active || subscriptionPacks.active)) || subscriptionPacks.active

    var hideConnected = (inputProps && inputProps.active) ? false : true //If we're not using the subpack store, we don't need to check for connected subpacks

    return(
      <div>
        <TextField
          select
          
          style={style || fullWidth ? {...style} : {width: Sizes.textfieldWidth}}

          label={label}
          value={value}
          onChange={handleChange}
          SelectProps={{
            native: true
          }}
          InputProps={{
            disableUnderline: true,
            classes: {
              root: classes.root,
              input: classes.input
            }
          }}
          InputLabelProps={{
            shrink: true,
            className: classes.formLabel
          }}
          margin='normal'
          fullWidth={fullWidth ? true : false}
          required={required ? true : false}
        >
        {value === '' || alwaysShowDefaultOption ? (
          <option key={'default'} value={value}>
            {Y`subpack_not_connected`}
          </option>
        ) : (
          <option key={'default'} value={value}>
            {value}
          </option>
        )}
        {(items && active && hideConnected) ? ( items.length > 0 && 
          // Remove already assigned subpacks and itself
          items.filter(subPack => (
                                  active.id !== subPack.id
                                )).filter(subpack => (
                                  active && active.downgradeTo &&
                                    active.downgradeTo.id !== subpack.id) ||
                                    !active.downgradeTo
                                ).filter(subpack => (
                                  active && active.upgradeTo &&
                                    active.upgradeTo.id !== subpack.id) ||
                                    !active.upgradeTo
                                )
                                 .map(subPack => (
            <option key={subPack.id} value={subPack.id}>
              {subPack.name}
            </option>
        ))): (active && !hideConnected) ? (items.length > 0 && 
          // List all subpacks exept itself
            items.filter(subPack => (
                active.id !== subPack.id
            )).map(subPack => (
            <option key={subPack.id} value={subPack.id}>
              {subPack.name}
            </option>
          ))) : 
          (items.length > 0 && 
            // List all subpacks
              items.map(subPack => (
              <option key={subPack.id} value={subPack.id}>
                {subPack.name}
              </option>
          )))
        }
        </TextField>
      </div>
    )
  }
}

SubscriptionPacksDropdown = connect(
  mapStateToProps,
  mapDispatchToProps
)(SubscriptionPacksDropdown)
export default withStyles(Styles)(SubscriptionPacksDropdown)



// WEBPACK FOOTER //
// ./src/common/dropdowns/subscription-packs-dropdown.js